export const rowIndexColumnName = "$rowIndex";
export const nativeTableRowIDColumnName = "$rowID";
export const nativeTableRowDeletedColumnName = "$rowDeleted";
